import React from 'react';
import { connect } from 'react-redux';
import { GridToolbar } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { Grid } from '../../shared/components';
import {
  findSessions,
  openSessionConfirmDialog,
  closeSessionConfirmDialog,
  removeSessionConfirmDialog
} from '../actions/event-session-list-actions';
import { withRouter } from '../../../components/withRouter';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Text } from '../../../ui';
import { ErrorMessage } from '../../../ui/components/common';

class GeneralCompetencyEventSessionList extends React.PureComponent {

  constructor() {
    super();
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleAddClicked = this.handleAddClicked.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleConfirmDialogClose = this.handleConfirmDialogClose.bind(this);
    this.handleRemoveConfirm = this.handleRemoveConfirm.bind(this);
  }

  async componentDidMount() {
    if (this.props.eventId) {
      await this.props.findSessions({ eventId: this.props.eventId });
    }
  }

  render() {
    const localizationService = provideLocalizationService(this);
    return (
      <>
        <Grid
          loading={this.props.loading}
          data={this.props.sessions}
          skip={this.props.skip}
          take={this.props.take}
          total={this.props.total}
          onPageChange={this.handlePageChange}
          onRowClick={this.handleRowClick}
          rowLink={(dataItem) => `/general_competency_events/${this.props.eventId}/sessions/${dataItem.id}/overview`}
          columns={[
            {
              field: 'name',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('generalCompetencyEventSession.name')
            },
            {
              field: 'startAt',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('generalCompetencyEventSession.startAt'),
              format: '{0:yyyy-MM-dd HH:mm}'
            },
            {
              field: 'durationMinutes',
              className: 'align-right',
              headerClassName: 'align-right',
              title: localizationService.toLanguageString('generalCompetencyEventSession.durationMinutes')
            }
          ]}
          actions={
            !this.props.readOnly && [{
              icon: 'delete',
              onClick: this.handleRemoveClick
            }]
          }
        >
          <GridToolbar>
            {!this.props.readOnly &&
              <Button themeColor='primary' onClick={this.handleAddClicked}>
                {localizationService.toLanguageString('custom.add')}
              </Button>
            }
          </GridToolbar>
        </Grid>
        {this.props.isConfirmDialogVisible &&
          <Dialog title={localizationService.toLanguageString('custom.confirm')} onClose={this.handleConfirmDialogClose}>
            {this.props.confirmDialogErrorMessage &&
              <ErrorMessage>{this.props.confirmDialogErrorMessage}</ErrorMessage>
            }
            <Text>{localizationService.toLanguageString('generalCompetencyEventSession.deleteConfirmDialogMessage')}</Text>
            <DialogActionsBar>
              <Button themeColor={'primary'} onClick={this.handleRemoveConfirm}>{localizationService.toLanguageString('buttons.delete')}</Button>
              <Button onClick={this.handleConfirmDialogClose}>{localizationService.toLanguageString('buttons.cancel')}</Button>
            </DialogActionsBar>
          </Dialog>
        }
      </>
    );
  }

  handleRowClick(e) {
    this.props.navigate(`/general_competency_events/${this.props.eventId}/sessions/${e.dataItem.id}/overview`);
  }

  handleAddClicked() {
    this.props.navigate(`/general_competency_events/${this.props.eventId}/sessions/create`);
  }

  async handlePageChange(e) {
    await this.props.findSessions({ eventId: this.props.eventId, skip: e.page.skip, take: e.page.take });
  }

  handleRemoveClick(row) {
    this.props.openSessionConfirmDialog(row.dataItem);
  }

  handleConfirmDialogClose() {
    this.props.closeSessionConfirmDialog();
  }

  handleRemoveConfirm() {
    this.props.removeSessionConfirmDialog({ eventId: this.props.eventId });
  }
}

const mapStateToProps = state => ({
  loading: state.generalCompetencyEventSessionList.loading,
  sessions: state.generalCompetencyEventSessionList.sessions,
  skip: state.generalCompetencyEventSessionList.skip,
  take: state.generalCompetencyEventSessionList.take,
  total: state.generalCompetencyEventSessionList.total,
  isConfirmDialogVisible: state.generalCompetencyEventSessionList.isConfirmDialogVisible,
  confirmDialogErrorMessage: state.generalCompetencyEventSessionList.confirmDialogErrorMessage
});

const mapDispatchToProps = dispatch => ({
  findSessions: (payload) => dispatch(findSessions(payload)),
  openSessionConfirmDialog: (payload) => dispatch(openSessionConfirmDialog(payload)),
  closeSessionConfirmDialog: () => dispatch(closeSessionConfirmDialog()),
  removeSessionConfirmDialog: (payload) => dispatch(removeSessionConfirmDialog(payload))
});

registerForLocalization(GeneralCompetencyEventSessionList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GeneralCompetencyEventSessionList));
